import { useAuth } from "../../src/auth/useAuth";
import { Button } from "../ui/button";

const UserSection = () => {
  const { user, logout } = useAuth();

  return (
    <div className="flex flex-col items-end">
      <div className="cursor-default text-xs hidden sm:block">Signed in as {user?.email}</div>
      <Button variant="ghost" size="sm" onClick={() => logout()}>
        Log out
      </Button>
    </div>
  );
};

export default UserSection;
